import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-error",
  "use": "icon-error-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-error\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z\" fill=\"#E15A55\" p-id=\"29017\" /><path d=\"M480 256h64v384h-64zM480 704h64v64h-64z\" fill=\"#FFFFFF\" p-id=\"29018\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol